import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { IOrderFillRequest } from '@ruby/modules/order-fill/model/order-fill.interface';
import * as OrderFillActions from '@ruby/modules/order-fill/store/actions/order-fill.actions';
import * as fromOrderFill from '@ruby/modules/order-fill/store/reducers/order-fill.reducer';
import { selectOrder } from '@ruby/modules/order-fill/store/selectors/order-fill.selectors';
import { EFeatureFlag } from '@ruby/shared/enums/feature-flags.enums';
import { EOrderFillDateInterval } from '@ruby/shared/enums/order-fill.enums';
import { LaunchDarklyService } from '@ruby/shared/services/analytics/launch-darkly.service';

@Component({
  selector: 'ng-order-fill-container',
  templateUrl: './order-fill.container.html',
  styleUrls: ['./order-fill.container.scss']
})
export class OrderFillContainer implements OnInit {
  store$: Observable<{
    state: fromOrderFill.State;
    loadingLocations: boolean;
    loadingPatterns: boolean;
    dateInterval: { previous?: EOrderFillDateInterval; current?: EOrderFillDateInterval };
  }>;
  doofFeature?: Promise<boolean>;

  constructor(
    private store: Store<{
      state: fromOrderFill.State;
      loadingLocations: boolean; loadingPatterns: boolean;
      dateInterval: { previous?: EOrderFillDateInterval; current?: EOrderFillDateInterval };
    }>,
    private launchDarklyService: LaunchDarklyService) {
    this.store$ = this.store.select(selectOrder).pipe(
      tap((st: {
        state: fromOrderFill.State;
        loadingLocations: boolean;
        loadingPatterns: boolean;
        dateInterval: { previous?: EOrderFillDateInterval; current?: EOrderFillDateInterval };
      }) => {
        if (st.loadingLocations || st.loadingPatterns || st.state.error) {
          this.store.dispatch(OrderFillActions.resetState());
        }
      })
    );
  }

  ngOnInit(): void {
    this.doofFeature = this.launchDarklyService.getFlagValue(EFeatureFlag.ACCESSNS_RUBY_DAILY_ORDER_FILL, false);
  }

  /**
   * Load Summary
   *
   * @summary Dispatch action load summary
   * @param $data: IOrderFillRequest
   * @returns void
   */
  loadSummary($data: IOrderFillRequest): void {
    this.store.dispatch(OrderFillActions.loadSummary({ data: $data }));
  }
}
